import { useCallback, useState } from 'react';
import { IGetWallet, WalletAPI } from '@tacans/shared-marketplace-layer';
import { useIsMounted } from 'src/hooks/useIsMounted';

export const useFetchUserWallets = () => {
    const [wallets, setWallets] = useState<IGetWallet[]>([]);
    const isMounted = useIsMounted();

    const fetchWallets = useCallback(async (login) => {
        try {
            const { data } = await WalletAPI.getWallets(login);
            isMounted(() => {
                setWallets(data?.wallets ?? []);
            });
        } catch (err) {
            console.error('useFetchUserWallets', err);
        }
    }, [isMounted]);

    return {
        wallets,
        fetchWallets
    };
};
